module.exports = __webpack_public_path__ + "static/img/08.0d9b83e0.png";